module.exports = __webpack_public_path__ + "01_short_black.aa4635d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_short_black.png
// module id = FZj/
// module chunks = 0